import { InitPagedData } from "./../Utils";
import { GoodInStateTypes, GoodInActionTypes } from "./GoodIn.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: GoodInStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchReport: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
  fetchPaged: resetApiCallState(InitPagedData),
};

const GoodInReducer = (
  state: GoodInStateTypes = INITIAL_STATE,
  action: any
): GoodInStateTypes => {
  switch (action.type) {
    case GoodInActionTypes.FETCH_ALL_GOOD_IN:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case GoodInActionTypes.FETCH_ALL_GOOD_IN_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case GoodInActionTypes.FETCH_ALL_GOOD_IN_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case GoodInActionTypes.FETCH_ALL_GOOD_IN_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };
    ///////////

    case GoodInActionTypes.FETCH_REPORT_GOOD_IN:
      return {
        ...state,
        fetchReport: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case GoodInActionTypes.FETCH_REPORT_GOOD_IN_RESET:
      return {
        ...state,
        fetchReport: resetApiCallState([]),
      };
    case GoodInActionTypes.FETCH_REPORT_GOOD_IN_FAILURE:
      return {
        ...state,
        fetchReport: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case GoodInActionTypes.FETCH_REPORT_GOOD_IN_SUCCESS:
      return {
        ...state,
        fetchReport: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    //////////
    case GoodInActionTypes.FETCH_PAGED_GOOD_IN:
      return {
        ...state,
        fetchPaged: {
          error: null,
          payload: InitPagedData,
          isPending: true,
          isSuccessful: false,
        },
      };
    case GoodInActionTypes.FETCH_PAGED_GOOD_IN_RESET:
      return {
        ...state,
        fetchPaged: resetApiCallState(InitPagedData),
      };
    case GoodInActionTypes.FETCH_PAGED_GOOD_IN_FAILURE:
      return {
        ...state,
        fetchPaged: {
          payload: InitPagedData,
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case GoodInActionTypes.FETCH_PAGED_GOOD_IN_SUCCESS:
      return {
        ...state,
        fetchPaged: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case GoodInActionTypes.FETCH_ONE_GOOD_IN:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case GoodInActionTypes.FETCH_ONE_GOOD_IN_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case GoodInActionTypes.FETCH_ONE_GOOD_IN_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case GoodInActionTypes.FETCH_ONE_GOOD_IN_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default GoodInReducer;
